import { ReactNode, TransitionStartFunction } from 'react';
import { Equipment } from 'services/equipment-search/types';
import {
  ServiceInsightDetailProps,
  dealerListProps
} from 'services/equipment/types';

export type EquipmentSuggestions = {
  equipments: Equipment[];
  otherEquipments: Equipment[];
};

export type UseEquipmentSuggestionsResult = {
  clearSuggestions: () => void;
  getEquipmentSuggestions: ({
    filter,
    searchTerm
  }: {
    filter: string;
    searchTerm: string;
  }) => void;
  error: {
    message?: string;
  } | null;
  isError: boolean;
  isFetching: boolean;
  status: string;
  suggestions: EquipmentSuggestions;
  isLoading: boolean;
  genericError: boolean;
  setGenericError: (value: boolean) => void;
};

export type EquipmentSuggestionsResultsProps = {
  error: {
    message?: string;
  } | null;
  fetchStatus: string;
  isSmallViewport: boolean;
  isFetching: boolean;
  onEquipmentSelected: (arg: Equipment) => void;
  searchTerm: string;
  suggestions: EquipmentSuggestions;
};

export type MyEquipmentList = {
  assetName: string;
  dcn?: string | null;
  id: string;
  imageURL: string;
  dealerCode?: string | null;
  isCommercialEngine: boolean;
  isSerialAndModelValid: boolean;
  isValidatedAsset: boolean;
  model: string;
  partNumber: string;
  productFamily: string;
  serialNumber: string;
  uniqueIndex: string;
  unvalidatedEquipmentId: string;
  unvalidatedItemListId: string;
  equipmentFamily?: string;
  productId?: string;
  seoUrl: string;
  equipmentSerialNumber?: string;
  assetId?: string;
  name?: string;
};

export type ServiceInsightFunctionProps = (
  equipmentDetails: MyEquipmentList,
  highlightSelectedEquipment?: boolean,
  isDisplayLink?: boolean
) => React.ReactNode;

export type MyEquipmentCardProps = {
  equipment: MyEquipmentList;
  currentIndex: number;
  selectTooltipText: string;
  searchTerm: string;
  uniqueIndex: string;
  userDetail: {
    isLoggedIn?: boolean;
    registerUrl?: string;
    isCspUser?: boolean;
    ccidProd?: string;
    isBuyOnBehalf?: boolean;
    isDealerUser?: boolean;
    firstName?: string;
    lastName?: string;
    email: string;
    companyName: string;
    phone?: string;
  };
  isRequestServiceFlag: boolean;
  isRequestServiceForIAFlag: boolean;
  startTransition: TransitionStartFunction;
  serviceInsightsDetails: ServiceInsightDetailProps;
  selectedEquipmentIndex?: number;
};

export type moreActionType = {
  id: string;
  label?: string;
  onClick?: () => void;
  isActionVisible?: boolean;
  gaLabel?: string;
  classNames?: string;
  gaContext?: string;
};

export type actionType = {
  text: string;
  key: string;
  onClickHandler: () => void;
};

export type actionTypes = {
  id: string;
  label?: string;
  icon?: ReactNode;
  onClick?: () => void;
  displayIcon?: boolean;
  showContext?: boolean;
  moreOptions?: moreActionType[];
  isActionVisible?: boolean;
  classNames?: string;
  status?: StatusType.error;
  gaLabel?: string;
  gaContext?: string;
  gaContextText?: string;
  isSelectedEquipment?: boolean;
};

export enum StatusType {
  error = 'error'
}

export type KebabActionProps = {
  REQUEST_SERVICE: boolean;
  CLEAR_SELECTION: boolean;
  PLEASE_SELECT: boolean;
  DELETE: boolean;
  VIEW_DASHBOARD: boolean;
  ALP_MAINTENANCE_REPAIRS: boolean;
  SHOP_PARTS: boolean;
  CAT_PARTS_DIAGRAM: boolean;
  EDIT: boolean;
  MORE: boolean;
  ALP_MAINTENANCE_REPAIRS_SINGLE_CARD: boolean;
  REQUEST_SERVICE_SINGLE_CARD: boolean;
};

export type actionItemsType = {
  actionItems?: actionTypes[];
};

export interface MyEquipmentKebabMenuProps {
  actionItems: actionTypes[];
  equipmentDetails: MyEquipmentList;
  userDetail: {
    isLoggedIn?: boolean;
    registerUrl?: string;
    isCspUser?: boolean;
    ccidProd?: string;
    isBuyOnBehalf?: boolean;
    isDealerUser?: boolean;
    isInstantAccessUser?: boolean;
  };
  dealerName?: string;
  startTransition?: TransitionStartFunction;
  dealerList?: dealerListProps[];
  selectedEquipmentIndex?: number;
  isDetailsCard?: boolean;
  isRequestServiceForIAFlag: boolean;
  gaContext?: string;
  isAssetLandingFeatureFlag?: boolean;
}

export type variantProps = {
  variant:
    | 'title'
    | 'body'
    | 'label'
    | 'display-xl'
    | 'display-lg'
    | 'display'
    | 'display-sm'
    | 'headline-lg'
    | 'headline'
    | 'title-sm'
    | 'label-lg'
    | 'label-sm'
    | 'body-sm'
    | 'footnote'
    | 'footnote-bold';
};
export type SearchParams = {
  page: string;
  pageSize?: string;
  q?: string;
  sortBy?: string;
  categoryId?: string;
  filterByEquipment?: string;
  model?: string;
  serialNumber?: string;
  facet?: string;
  scrollToProduct?: string;
};
